import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import {
  onClickOutside,
  useBreakpoints,
  breakpointsTailwind,
} from '@vueuse/core';
import { useCountryByLang, useLanguages } from '@/composables';

interface Props {
  dark?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  props: {
    dark: { type: Boolean }
  },
  setup(__props: any, { expose }) {


const IS_SHOWN_FLAGS = false;
const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = breakpoints.greater('xl');

const isOpen = ref(false);
const { languages, currentLocale, currentLocaleName } = useLanguages();

const close = () => {
  isOpen.value = false;
};
const toggle = () => {
  isOpen.value = !isOpen.value;
};

const target = ref(null);

onClickOutside(target, () => {
  close();
});

const getFlagIcon = (code: string) => {
  return `/svg/flags/${useCountryByLang(code)?.toUpperCase()}.svg`;
};

expose({
  close,
  toggle,
});

return { __sfc: true,IS_SHOWN_FLAGS, breakpoints, isDesktop, isOpen, languages, currentLocale, currentLocaleName, close, toggle, target, getFlagIcon }
}

})